import axios from 'axios'
import { Conflict } from '@src/data/types/Conflict'

// No need to overcomplicate default api client configurations via redux and instances
// Axios is already a singleton and can be used as is
axios.defaults.baseURL = import.meta.env.VITE_BACKOFFICE_API_URL
axios.defaults.headers['X-requestor'] = `backofficeapp:${import.meta.env.VITE_VERSION}`

// Callback for reporting conflicts (409 errors) - set by AppConfigProvider
let reportConflict: ((conflict: Conflict) => void) | null = null

export const setReportConflict = (callback: typeof reportConflict) => {
  reportConflict = callback
}

// Callback for reporting a deprecated client version - set by AppConfigProvider
let reportVersionDeprecated: (() => void) | null = null

export const setReportVersionDeprecated = (callback: typeof reportVersionDeprecated) => {
  reportVersionDeprecated = callback
}

// Response interceptor to handle 409 Conflict errors and detect outdated client versions
axios.interceptors.response.use(
  (response) => {
    const latestVersion = response.headers?.['x-requestor-latest-version'] as string | undefined
    const currentVersion = import.meta.env.VITE_VERSION
    if (latestVersion && currentVersion && latestVersion !== currentVersion) {
      reportVersionDeprecated?.()
    }
    return response
  },
  (error: Error) => {
    if (axios.isAxiosError(error) && error.response?.status === 409) {
      const conflictData = error.response.data as Conflict | undefined
      if (conflictData && reportConflict) {
        reportConflict({
          userId: conflictData.userId,
          userFullName: conflictData.userFullName,
          updatedOn: conflictData.updatedOn,
        })
      }
    }
    return Promise.reject(error)
  },
)

export const setApiClientAuthorization = (token: string) => {
  axios.defaults.headers.Authorization = `Bearer ${token}`
}

export const getApiClient = () => {
  return axios
}
export default axios
